<template>
  <div>
    <ul class="sscNo" v-if="bigClass == 'SSC' || bigClass == '11X5' || bigClass == '3D'|| bigClass == 'PL3'|| bigClass == 'PCDD'|| bigClass == 'CQSSC'">
      <li v-for="(item, index) in drawList" :key="index">{{ item }}</li>
    </ul>
    <ul class="lhcNo" v-if="bigClass == 'LHC'">
      <li v-for="(item, index) in drawList" :key="index" v-show="index + 1 != drawList.length && 'true'">
        <div :class="'sebo-' + findNumbColor(item)" v-if="LotteryLatelyLpVo.length > 1"> {{ item }} </div>
        <div
          :class="[index == 0 || index == 1 ? 'sebo-red' : '', index == 2 || index == 3 ? 'sebo-blue' : '', index == 4 || index == 5 ? 'sebo-green' : '']"
          v-else> {{ item }} </div>
        <div> {{ findNumbAnimal(item, getAnimalList()) }} </div>
      </li>
      <li>
        <div class="lhcPlus"> + </div>
      </li>
      <li>
        <div :class="'sebo-' + findNumbColor(drawList[drawList.length - 1])" v-if="LotteryLatelyLpVo.length > 1"> {{
      drawList[drawList.length - 1] }} </div>
        <div class="sebo-red" v-else> {{ drawList[drawList.length - 1] }} </div>
        <div> {{ findNumbAnimal(drawList[drawList.length - 1], getAnimalList()) }} </div>
      </li>
    </ul>
  </div>
</template>
<script>
import lotteryRandBallDF from "~/mixins/lotteryRandBallDF.mixins";
import lhcMixins from "~/mixins/lhc.mixins";
export default {
  mixins: [lotteryRandBallDF, lhcMixins],
  data() {
    return {
    };
  },
  props: {
    lottery: {
      type: [Object],
      default: null
    },
  },
  methods: {
    getAnimalList(periodsNumber) {
      return this.getCurrYearAnimal(this.lottery.periodsNumber.slice(0, 4));
    }
  },
  computed: {
    // 开奖中
    LotteryLatelyLpVo() {
      if (this.lottery) {
        return this.lottery.drawingNumber
          ? this.lottery.drawingNumber.split(",")
          : [];
      } else {
        return [];
      }
    }
  }
}
</script>
<style lang="less">
.home-menu-component-df,.record-menu-components-df,.chart-menu-components-df {
  .sscNo li {
    width: 46.5px;
    height: 46.5px;
    border-radius: 100%;
    background: linear-gradient(180deg, #fff, #f1efef);
    border: 1px solid #c0c5d2;
    box-shadow: 0 1px 3px #d4d4d4, inset 0 -1px 5px hsla(0, 0%, 100%, .25);
    margin: 20px 10px 0 0;
    font-size: 20px;
    color: #444;
    font-weight: 500;
  }

  .lhcNo li {
    display: inline-flex;
    flex-direction: column;
  }

  .lhcNo li>div.lhcPlus {
    width: 20px;
    color: #333 !important
  }

  .lhcNo li>div:first-child {
    width: 38px;
    height: 38px;
    border-radius: 100%;
    margin: 20px 6px 0 0;
    font-size: 16px;
    color: #fff;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center
  }

  .lhcNo li>div:last-child {
    width: 38px;
    font-weight: 400;
    margin: 5px 6px 0 0;
    display: flex;
    justify-content: center;
    align-items: center
  }

  .lhcNo li .sebo-red {
    background: linear-gradient(180deg, #f7846b, #d04a4c);
    border: 1px solid #ffaaab;
    box-shadow: 0 1px 3px #d4d4d4, inset 0 -1px 2px rgba(255, 203, 203, .6)
  }

  .lhcNo li .sebo-blue {
    background: linear-gradient(180deg, #72bbff, #1787d9);
    border: 1px solid #a2cdff;
    box-shadow: 0 1px 3px #d4d4d4, inset 0 -1px 2px rgba(203, 249, 255, .6)
  }

  .lhcNo li .sebo-green {
    background: linear-gradient(180deg, #69dc89, #1aa950);
    border: 1px solid #83dea6;
    box-shadow: 0 1px 3px #d4d4d4, inset 0 -1px 2px rgba(203, 255, 222, .6)
  }
}
</style>